export default __webpack_public_path__ + "static/users2-ea867adb4486daa5dab8d0dec88c16a8.png";